/* eslint-disable import/no-unresolved */
import aialHero from '../assets/images/aial/hero.png';
import aialLogo from '../assets/images/aial/logo.svg';
import horizonOneFooterLogo from '../assets/images/horizonOneLogo/logo.png';
import aialHome from '../assets/images/aial/heroes/pullman-hotel.jpg';
import aialSelectContract from '../assets/images/aial/heroes/quad.jpeg';
import aialLogAJob from '../assets/images/aial/heroes/fonterra.jpeg';
import aialReactive from '../assets/images/aial/heroes/manawa-bay.jpeg';
import aialPlanned from '../assets/images/aial/heroes/foodstuffs.jpeg';
import aialSchedule from '../assets/images/aial/heroes/hellmann.jpeg';
import aialAssets from '../assets/images/aial/heroes/mpi.jpeg';

// Build-time branding, selected by GATSBY_BRAND (Gatsby inlines GATSBY_* env vars).
// Each brand overrides ONLY what differs from the base theme / Prismic content, so
// the default (aquaheat / unset) changes nothing. Set GATSBY_BRAND per-site in the
// Netlify environment - the deploy workflow passes it through to the build.
export interface Brand {
  welcomeText?: string;
  logo?: string;       // overrides the Prismic site logo when set
  footerLogo?: string;     // overrides the HEG logo in the login and select-contract footer when set
  footerLogoAlt?: string;  // alt text that goes with footerLogo
  heroImage?: string;  // default hero override (login, select-contract)
  heroImages?: { [key: string]: string };  // per-page hero overrides, keyed by page
  heroContain?: boolean;                    // AIAL: show the hero at native aspect (right-aligned, height-locked) with a clip-path wedge, instead of full-bleed cover
  colors?: { [key: string]: string };
  typography?: { [key: string]: string };
}

const brands: { [key: string]: Brand } = {
  // Default - base theme + whatever Prismic serves. No overrides.
  aquaheat: {},

  // Auckland Airport (AIAL) - monochrome brand, black buttons, their hero + logo.
  aial: {
    welcomeText: 'Welcome to Auckland Airport Client Portal',
    logo: aialLogo,
    footerLogo: horizonOneFooterLogo,
    footerLogoAlt: 'Horizon One logo',
    heroImage: aialHero,
    heroImages: {
      home: aialHome,
      selectContract: aialSelectContract,
      logAJob: aialLogAJob,
      reactive: aialReactive,
      planned: aialPlanned,
      maintenanceSchedule: aialSchedule,
      assets: aialAssets,
    },
    heroContain: true,
    // Horizon One palette, sampled from the logo (APPROXIMATE - the sample was 16-step quantised).
    // Contrast on white: deep green 4.9, dark grey 10.4, #6e6e6e 5.1 (all AA). The bright green
    // (2.7) and light green (2.2) FAIL AA as text, so they are accents and fills only - never text.
    colors: {
      primaryColor: '#308040',          // deep green - buttons, accents; hover is darken() of this
      secondaryColor: '#60B040',        // bright green - secondary accent, fills only
      primaryFontColor: '#404040',      // dark grey, the "Horizon" wordmark
      secondaryFontColor: '#6e6e6e',    // muted text; the logo's mid grey #909090 is only 3.2:1, this is 5.1:1
      baseIconColor: '#404040',
      primaryBackgroundColor: '#ffffff',
    },
    typography: {
      baseFontFamily:
        '"AKL Sans", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      titleFontFamily:
        '"AKL Sans", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
  },
};

const activeName: string = process.env.GATSBY_BRAND || 'aquaheat';
const activeBrand: Brand = brands[activeName] || brands.aquaheat;

export default activeBrand;
